document.getElementById('HeaderMenu-contact').addEventListener('click', function(event) {
    event.preventDefault();
    var popup = document.getElementById('contact-popup');
    popup.style.display = 'block';
});

document.getElementById('close-popup').addEventListener('click', function() {
    var popup = document.getElementById('contact-popup');
    popup.style.display = 'none';
});

// Optional: Add a close functionality when clicking outside the popup
window.addEventListener('click', function(event) {
    var popup = document.getElementById('contact-popup');
    if (event.target == popup) {
        popup.style.display = 'none';
    }
});




document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('slider');
    const leftArrow = document.querySelector('.left-arrow');
    const rightArrow = document.querySelector('.right-arrow');

    let currentIndex = 0;

    const scrollToIndex = (index) => {
      const itemWidth = slider.clientWidth;
      slider.scrollTo({ left: index * itemWidth, behavior: 'smooth' });
    };

    leftArrow.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        scrollToIndex(currentIndex);
      }
    });

    rightArrow.addEventListener('click', () => {
      const itemCount = slider.querySelectorAll('li').length;
      if (currentIndex < itemCount - 1) {
        currentIndex++;
        scrollToIndex(currentIndex);
      }
    });
});




  document.addEventListener('DOMContentLoaded', function () {
    const reloadLinks = [
      document.getElementById('HeaderDrawer-our-uniforms'),
      document.getElementById('HeaderDrawer-partnership-process')
    ];

    const drawerTrigger = document.getElementById('Details-menu-drawer-container');

    reloadLinks.forEach(function (link) {
      if (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();

          // Optional: Close or trigger the menu drawer
          if (drawerTrigger) {
            drawerTrigger.click();
          }

          // Force full reload with new URL (hash or not)
          const href = this.getAttribute('href');
          const fullUrl = new URL(href, window.location.origin);

          // Trick: Always reload by assigning a slightly new URL
          if (window.location.href === fullUrl.href) {
            // Already on this exact URL, force reload
            window.location.reload(true);
          } else {
            // Navigate to new URL (even if it's a hash)
            window.location.href = fullUrl.href;
            window.location.reload(true);
          }
        });
      }
    });
  });




